import React from "react"
import PropTypes from "prop-types"

import Link from "../utils/Link"
import Image from "../utils/Image"
import SocialLink from "../utils/SocialLink"

import Box from "../atoms/Box"
import Flex from "../atoms/Flex"
import { Paragraph } from "../atoms/Typography"
import MorphicBadge from "../atoms/MorphicBadge"

import Newsletter from "../molecules/Newsletter"

const FooterText = ({
  logo,
  text,
  textPosition,
  align,
  hideMorphicBadget,
  morphicBadgeTier,
  badgeBackground,
  socialLinks,
  socialLinkStyles,
  useNewsletter,
  newsletter,
  newsletterPosition,
  newsletterJustify,
  ...rest
}) => {
  const socialStylesObj =
    socialLinkStyles === undefined || socialLinkStyles === null
      ? {
          color: "primary",
          theme: "highlight",
          bg: 3,
          iconStyle: "solid",
        }
      : socialLinkStyles
  const noSocials = socialLinks?.length === 0 || socialLinks === undefined
  const logoPosition = textPosition === "left" ? "left center" : "right center"
  return (
    <Flex
      flexDirection="column"
      alignItems={align === "right" ? "flex-end" : ""}
      {...rest}
    >
      {logo && (
        <Box width={{ _: 9, md: 11 }} height={3} mb={3}>
          <Link aria-label="Go to home page link" to="/">
            <Image
              alternativeText="Footer Logo"
              {...logo}
              style={{ height: "100%" }}
              imgStyle={{
                objectFit: "contain",
                objectPosition: logoPosition,
              }}
            />
          </Link>
        </Box>
      )}
      {!noSocials && (
        <Box className="social" mt={3} mb={4}>
          {socialLinks?.map(socialLink => {
            return (
              <SocialLink
                {...socialLink}
                {...socialStylesObj}
                mr={textPosition === "left" ? 4 : 0}
                ml={textPosition === "right" ? 4 : 0}
              />
            )
          })}
        </Box>
      )}
      {text && (
        <Paragraph
          variant="footerLink"
          as="div"
          mt={3}
          textAlign={textPosition}
        >
          {text}
        </Paragraph>
      )}
      {!hideMorphicBadget && (
        <MorphicBadge
          morphicBadgeTier={morphicBadgeTier}
          badgeBackground={badgeBackground}
          mt={logo || text ? 3 : 0}
        />
      )}
      {useNewsletter && newsletterPosition === "underLogo" && (
        <Box mb={4} mt={5}>
          <Newsletter
            integration={newsletter?.integration}
            formStyle={newsletter?.formStyle}
            formWidth={newsletter?.formWidth}
            title={newsletter?.title}
            titleAlignment={newsletter?.titleAlignment}
            boxShadow={newsletter?.boxShadow}
            borderRadius={newsletter?.borderRadius}
            justify={newsletterJustify}
          />
        </Box>
      )}
    </Flex>
  )
}

FooterText.propTypes = {
  logo: PropTypes.object,
  text: PropTypes.string,
  align: PropTypes.oneOf(["left", "right"]).isRequired,
  hideMorphicBadget: PropTypes.bool,
  morphicBadgeTier: PropTypes.oneOf(["morphic", "enterprise"]),
  ...Box.propTypes,
}

export default FooterText
